<template>
  <div class="page-box">
    <div v-if="type == 0" class="top-box">
      <img src="@/assets/auth/succ_icon.png" class="succ-icon" />
      <div class="title">商户审核成功</div>
      <div class="text">
        可前往 <span style="color: #ff4741">《联动pay》App</span> 或
        <span style="color: #ff4741">《UMF联动pay》</span> 小程序查看商户信息
      </div>
    </div>
    <div v-else class="top-box">
      <img src="@/assets/auth/succ_icon2.png" class="succ-icon" />
      <div class="title">商户信息审核中</div>
      <div class="desc">请耐心等待系统审核</div>
      <div class="text">
        可前往 <span style="color: #ff4741">《联动pay》App</span> 或
        <span style="color: #ff4741">《UMF联动pay》</span> 小程序查看审核结果
      </div>
    </div>
    <div class="btn-content">
      <wx-open-launch-weapp
        id="launch-btn"
        appid="wxff3bb18717817110"
      ></wx-open-launch-weapp>
    </div>
  </div>
</template>

<script>
import { getAuthInfo } from "@/api/common";
import wx from "weixin-js-sdk";

export default {
  data() {
    return {
      type: this.$route.params.type,
    };
  },

  mounted() {
    let launchBtn = document.getElementById("launch-btn");
    // 清空原有内容
    launchBtn.innerHTML = "";
    // 创建 script 标签
    const script = document.createElement("script");
    script.type = "text/wxtag-template";
    script.textContent = `
      <style>
        .btn {
          width: 169px;
          height: 48px;
          background-color: #ff4741;
          border-radius: 12px;
          color: white;
          font-size: 15px;
          padding: 0 15px;
          white-space: nowrap;
          display: flex;
          align-items: center;
          justify-content: center;
          border: none;
        }
      </style>
      <button class="btn">前往小程序</button>
    `;
    launchBtn.appendChild(script);
    this.weiConfig();
  },

  methods: {
    weiConfig() {
      if (this.$isWeiXin()) {
        getAuthInfo({ urlType: 1 }).then((res) => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，签名
            nonceStr: res.nonceStr, // 必填，签名
            signature: res.signature, // 必填，签名
            jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
          });
          wx.ready((res) => {});
        });
      } else {
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page-box {
  padding-top: 198px;
  .top-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 150px;
    .succ-icon {
      width: 140px;
      height: 140px;
      margin-bottom: 20px;
    }
    .title {
      font-size: 34px;
      color: #333333;
      margin-bottom: 20px;
    }
    .desc {
      font-size: 28px;
      color: #333333;
      margin-bottom: 30px;
    }
    .text {
      padding: 0 105px;
      font-size: 28px;
      color: #999999;
    }
  }
  .btn-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
